var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJoinPresaleMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 328,
    height: 44,
    viewBox: "0 0 328 44",
    fill: "#6C84F8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M318.058 43H2C1.44772 43 1 42.5523 1 42V20V10.771C1 10.5229 1.09222 10.2836 1.25874 10.0997L9.20104 1.32878C9.39061 1.11943 9.65987 1 9.94231 1L326 1C326.552 1 327 1.44772 327 2V20V33.229C327 33.4771 326.908 33.7164 326.741 33.9003L318.799 42.6712C318.609 42.8806 318.34 43 318.058 43Z",
    fill: "#6C84F8",
    stroke: "#6C84F8",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinPresaleMobile);
export default __webpack_public_path__ + "static/media/join-presale-mobile.9dfdbadce1cbdf7b3bbdddf27cfb9044.svg";
export { ForwardRef as ReactComponent };